"use client";
import { Suspense } from "react";
import { Skeleton } from "@/components/ui/skeleton";
import { parseHtml } from "@/lib/utils";
import { Link } from "@/components/CustomLink";
import { Button } from "@/components/ui/button";
import PlusCircleIcon from "@heroicons/react/24/outline/PlusCircleIcon";
import { ROUTES } from "@/@core/constants/routes";
import Image from "next/image";
import { useTranslation } from "@/hooks/translationContext";

interface Props {
  description: string;
}

export default function AboutUsPage({ description }: Props) {
  const { t } = useTranslation()

  return (
    <div className="text-primary font-medium font-sans mt-4">
      <Suspense fallback={<Skeleton className="w-full h-[378px]" />}>
        <div className="w-full h-full gap-x-8 gap-y-4 flex md:flex-row flex-col-reverse items-center md:items-start">
          <p
            className="text-[14px] font-semibold text-primary"
            dangerouslySetInnerHTML={{ __html: parseHtml(description) }}
          ></p>
        </div>
      </Suspense>

      <Suspense fallback={<Skeleton className="w-full h-[46px]" />}>
        <div className="py-8">
          <Link href={ROUTES.VENUE.CREATE}>
            <Button
              className="w-full self-scretch justify-between"
              variant="accent"
              size="lg"
            >
              {t("venue-add-title", {
                defaultValue: "Mekan Ekle",
              })}{" "}
              <PlusCircleIcon className="size-5" />
            </Button>
          </Link>
        </div>
      </Suspense>
    </div>
  );
}
